import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const PROFILES_REQUEST = 'FETCH_PROFILES_REQUEST';
export const PROFILES_FAILURE = 'FETCH_PROFILES_FAILURE';
export const PROFILES_SUCCESS = 'FETCH_PROFILES_SUCCESS';

export const fetchProfiles = () => {
    return function(dispatch) {
        dispatch(fetchRequest());
        return axios(apiRequestOptions(apiPath.PROFILES.LIST))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchRequest = () => {
    return {
        type: PROFILES_REQUEST,
    }
};

const fetchFailure = (error) => {
    return {
        type: PROFILES_FAILURE,
        error,
    }
};

const fetchSuccess = (data) => {
    return {
        type: PROFILES_SUCCESS,
        data,
    }
};